<template src="./template.html" ></template>

<script>
import MyAlert from '../../components/alert/MyAlert.vue'
import MyAddButtons from '../add/Buttons.vue'
import MyRoles from '../../components/MyRoles.vue'
import MyComment from '../../components/MyComment.vue'

export default {
  name: 'user-items',
  props: ['formTitle'],
  data() {
    return {
      valid: false,
      alert: false,
      show: false,
      model: {},
      rules: {
        required: value => !!value || 'اجباری',
        min: v => v && v.length >= 6 || 'حداقل 6 کاراکتر',
        confirm: v => v && v === this.model.password || "مغایرت دارد"
      },
    }
  },
  async beforeCreate() {
    this.formState = this.$router.currentRoute.path.split("/")[2]
    this.route = this.$store.getters.pageInfo.route
    if (this.formState === 'edit') {
      let _mid = this.$router.currentRoute.path.split("/")[3]
      let data = {
        url: `/api/${this.route}`,
        params: {
          mid: _mid
        },
      }
      await this.$store.dispatch('getInfo', data)
      this.model = this.$store.getters.editData
      // console.clear();
      // console.log(this.model);
    }
  },
  methods: {
    async onSave() {
      //
      let _method = 'POST'
      if (this.formState === 'edit' || this.formState === 'password') {
        _method = 'PUT'
      }
      this.$refs.form.validate()
      if (this.formState === 'password') {
        this.model._id = this.$router.currentRoute.path.split("/")[3]
      }
      let _data = {
        method: _method,
        url: `/api/${this.route}`,
        data: {
          data: this.model
        },
      }
      if (this.valid) {
        await this.$store.dispatch('save', _data)
        let res = this.$store.getters.saveData

        if (res && (res.insert || res.update)) {
          this.alert = true
        }
        if (this.formState === 'password') this.$store.dispatch("logout")
        // this.$router.go(-1)
      }
    },
  },
  components: {
    MyAlert,
    MyAddButtons,
    MyRoles,
    MyComment,
  },
}
</script>
